// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type xGoogleAnalyticsHandlerType = {
    customVirtualPageViewEventName?: string;
    includeCustomVirtualPageViewEvent?: boolean;
};

export type xGoogleAnalyticsStateType = Readonly<xGoogleAnalyticsHandlerType>;

const initialGoogleAnalytics: xGoogleAnalyticsStateType = {
    includeCustomVirtualPageViewEvent: false,
} as xGoogleAnalyticsStateType;

const reducer = {
    "xGoogleAnalytics/update": (
        draft: Draft<xGoogleAnalyticsStateType>,
        action: { data: xGoogleAnalyticsHandlerType },
    ) => {
        draft.customVirtualPageViewEventName = action.data.customVirtualPageViewEventName ?? "";
        draft.includeCustomVirtualPageViewEvent = action.data.includeCustomVirtualPageViewEvent ?? false;
    },
};

const xGoogleAnalytics = createTypedReducerWithImmer(initialGoogleAnalytics, reducer);

(reducers as any).xGoogleAnalytics = xGoogleAnalytics;

export type xGoogleAnalyticsState = {
    xGoogleAnalytics: xGoogleAnalyticsStateType;
};

type xGoogleAnalyticsReducers = {
    [key: string]: typeof xGoogleAnalytics;
};

export type xGoogleAnalyticsActions =
    | Parameters<xGoogleAnalyticsReducers[keyof xGoogleAnalyticsReducers]>[1]
    | AnyAction;
